import { render } from "./register-banner.vue?vue&type=template&id=3b9b9fb2"
import script from "./register-banner.vue?vue&type=script&lang=js"
export * from "./register-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__